import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=40c27adc&scoped=true"
import script from "./MessagesView.vue?vue&type=script&lang=js"
export * from "./MessagesView.vue?vue&type=script&lang=js"
import style0 from "./MessagesView.vue?vue&type=style&index=0&id=40c27adc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c27adc",
  null
  
)

export default component.exports